import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { ERROR_500_REDIRECT } from '../final-pages/final-pages.constants';
 
/**
 * Lista de URLs que deben ser excluidas del interceptor
 * Puedes agregar aquí las rutas que no quieres que sean interceptadas
 */
const excludedUrls: string[] = [
  'startsarlaftevaluation',
  'pullersarlaft'
  // Ejemplo: '/api/health-check',
  // Ejemplo: '/api/monitoring'
];
 
/**
 * Determina si una petición debe ser excluida del interceptor
 * @param url - La URL de la petición HTTP a evaluar
 * @param headers - Los headers de la petición
 * @returns true si debe ser excluida, false en caso contrario
 */
const shouldSkipInterception = (url: string, headers: any): boolean => {
  // Verificar si tiene el header para saltar el interceptor
  if (headers.has('X-Skip-Error-Interceptor')) {
    return true;
  }
 
  // Verificar si la URL está en la lista de excluidas
  return excludedUrls.some(excludedUrl => url.includes(excludedUrl));
};
 
/**
 * Interceptor HTTP funcional para capturar errores de servidor (500) y redirigir a página de error
 *
 * Este interceptor:
 * - Intercepta todas las peticiones HTTP salientes
 * - Captura específicamente errores con status 500 (Internal Server Error)
 * - Redirige automáticamente al usuario a la ruta '/error'
 * - Permite excluir URLs específicas usando el header 'X-Skip-Error-Interceptor'
 * - Permite excluir URLs agregándolas al array excludedUrls
 *
 * @param req - La petición HTTP original
 * @param next - El siguiente handler en la cadena de interceptors
 * @returns Observable con el resultado de la petición o manejo de error
 */
export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  
 
 
  // Verificar si la URL debe ser excluida del interceptor
  if (shouldSkipInterception(req.url, req.headers)) {
    return next(req);
  }
 
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log('ERROR CAPTURADO EN INTERCEPTOR:', error);
      console.log('error.status:', error.status);
      
      //  500 (Internal Server Error)
      if (error.status >= 500) {
        console.error(`Error ${error.status} interceptado:`, {
          url: req.url,
          method: req.method,
          error: error.message,
          status: error.status,
          statusText: error.statusText,
          timestamp: new Date().toISOString()
        });
 
        // Redirigir a la página de error personalizada
        
         router.navigate([ERROR_500_REDIRECT]);
       
        // Retornar EMPTY para evitar que el error se propague a otros manejadores
        // Esto corta el flujo del observable y evita que el componente procese la respuesta
        return EMPTY;
      }
 
      // Re-lanzar el error para otros status codes
      return throwError(() => error);
    })
  );
};